// Quick Setup for a new venue (src/modules/venue-port): pick a type, describe the venue, Generate.
// A flat file route like venues.$id.studio.tsx: it outranks the legacy $ splat.
import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { VenueNewRoute } from '../modules/venue-port/tkt/VenueRoutes';
import { venueNav } from '../modules/venue-port/tkt/venueNav';

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);

export const Route = createFileRoute('/venues/new')({
  validateSearch: (s: Record<string, unknown>): { type?: string; draft?: string; phase?: string } => ({ type: str(s.type), draft: str(s.draft), phase: str(s.phase) }),
  component: function VenueNew() {
    const search = Route.useSearch();
    const nav = venueNav(useNavigate(), '/venues/new');
    return <VenueNewRoute search={search} nav={nav} />;
  },
});
